<div class="list-container" >
    <dynamic-table [props]="props">
        <table class="table">
            <thead>
                <tr class="table-header">
                    <th id="Number" class="table-header-title">{{'contracts.numberAndType' | translate}}</th>
                    <th id="ResidualValue" class="table-header-title">{{'contracts.residualValue' | translate}}</th>
                    <th id="ContractValue" class="table-header-title">{{'contracts.outstandingAmount' | translate}}</th>
                    <th id="OverdueAmounts" class="table-header-title">{{'contracts.overdueAmount' | translate}}</th>
                    <th id="SigningDate" class="table-header-title">{{'contracts.contractPeriod' | translate}}</th>
                    <th id="Balloon" class="table-header-title">{{'contracts.balloonPayment' | translate}}</th>
                    <th id="NextPayment" class="table-header-title">{{'contracts.nextInstallmentAmount' | translate}}</th>
                    <th id="TotalInstallmentsNumber" class="table-header-title">{{'contracts.installments' | translate}}</th>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngFor="let contract of contracts">
                    <tr class="row-container ccc ccc-table-row ccc-hover" (click)="viewDetailsHandler(contract.externalEntityId)" role="button">
                        <td id="Number" class="column-content">
                            <div HJSuppress class="table-main-td">{{contract.number}}</div>
                            @switch (contract.dictionaryContractType.code) {
                                @case (ContractType.OPERATIONAL_LEASING) {
                                    <div HJSuppress>{{'contracts.contractType.operationalLeasing' | translate}}</div>
                                }
                                @case (ContractType.FINANCIAL_LEASING) {
                                    <div HJSuppress>{{'contracts.contractType.financialLeasing' | translate}}</div>
                                }
                                @case (ContractType.CREDIT) {
                                    <div HJSuppress>{{'contracts.contractType.credit' | translate}}</div>
                                }
                            }
                        </td>
                        <td HJSuppress id="ResidualValue" class="column-content">
                            {{ contract.dictionaryContractType.code === ContractType.FINANCIAL_LEASING
                                ? (contract.residualValue | number : '1.2-2') + ' ' + contract.dictionaryCurrencyCode
                                : '-'
                            }}
                        </td>
                        <td HJSuppress id="ContractValue" class="column-content">
                            {{ contract.outstandingAmount | number : '1.2-2' }} {{ contract.dictionaryCurrencyCode }}
                        </td>
                        <td HJSuppress id="OverdueAmounts" class="column-content" [ngClass]="{'overdue-warning': contract.hasOverdue}">
                            {{
                                contract.hasOverdue 
                                ? contract.overdueAmountsString 
                                : (0 | number:'1.2-2')
                            }} {{ contract.dictionaryCurrencyCode }}
                        </td>
                        <td id="SigningDate" class="column-content">
                            <div HJSuppress class="d-flex align-items-center gap-1">
                                <span>{{contract.signingDate | localizedDate}}</span>
                                -
                                <span>{{contract.terminationDate | localizedDate}}</span>
                            </div>
                        </td>
                        <td HJSuppress id="Balloon" class="column-content">
                            {{ contract.dictionaryContractType.code === ContractType.CREDIT
                                ? (contract.balloon | number : '1.2-2') + ' ' + contract.dictionaryCurrencyCode
                                : '-'
                            }}
                        </td>
                        <td HJSuppress id="NextPayment" class="column-content">
                            {{ contract.nextPayment | number : '1.2-2' }} {{ contract.dictionaryCurrencyCode }}
                        </td>
                        <td id="TotalInstallmentsNumber" class="column-content">
                            <div HJSuppress class="d-flex align-items-center text-secondary">
                                <span class="text-primary">
                                    {{ contract.paidInstallmentsNumber }}
                                </span>
                                /
                                <span>{{ contract.totalInstallmentsNumber }}</span>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </dynamic-table>
</div>